import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    handleListDeleteIconMouseEnter,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    FormControlLabel,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { ComboPadraoMultiple } from 'views/Components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class VeiculoList extends Component {
    state = {
        searchFilter: loadStoredJson('veiculoSearchFilter', {
            nroveiculo: '',
            descveiculo: '',
            capacidadepax: '',
            marcas: [],
            modelos: [],
            fornecedores: [],
            veiculoproprio: false,
            situacaoInativoFilter: ANAO
        }),
        veiculos: [],
        listaMarcas: [],
        listaModelos: [],
        listaFornecedores: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: '',
        totalItems: 0,
        page: Number(sessionStorage.getItem('veiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('veiculoRowsPerPage')) || 10
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const [listaModelos] = await Promise.all([
            this.loadModelos(),
            this.loadMarcas(),
            this.loadFornecedores()
        ]);

        this.loadVeiculos(listaModelos);
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('veiculoSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('veiculoPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('veiculoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'veiculoSearchFilter',
            'veiculoPage',
            'veiculoRowsPerPage'
        ]);
    };

    /* Carrega os fornecedores */
    loadFornecedores = async () => {
        try {
            const params = `?page=1&limit=500&transportadora=S`;
            const response = await api.get(`/fornecedor/active/true${params}`);
            const listaFornecedores = response.data.map(fornecedor => ({
                id: fornecedor.codfornecedor,
                item: fornecedor.descfornecedor
            }));

            this.safeSetState({ listaFornecedores });

            return listaFornecedores;
        } catch (error) {
            console.error('Erro ao carregar fornecedores do veículo', error);

            return [];
        }
    };

    /* Carrega as marcas de veículo */
    loadMarcas = async () => {
        try {
            const response = await api.get('/marcaveiculo');
            const marcas = Array.isArray(response.data)
                ? response.data
                : (Array.isArray(response.data?.data) ? response.data.data : []);
            const listaMarcas = marcas.map(marca => ({
                id: marca.codmarcaveiculo,
                item: marca.descmarcaveiculo
            }));

            this.safeSetState({ listaMarcas });

            return listaMarcas;
        } catch (error) {
            console.error('Erro ao carregar marcas de veículo', error);

            return [];
        }
    };

    /* Carrega os modelos de veículo */
    loadModelos = async () => {
        try {
            const response = await api.get('/modeloveiculo');
            const modelos = Array.isArray(response.data)
                ? response.data
                : (Array.isArray(response.data?.data) ? response.data.data : []);
            const listaModelos = modelos.map((modelo) => ({
                id: modelo.codmodeloveiculo,
                item: modelo.descmodeloveiculo,
                codmarcaveiculo: modelo.codmarcaveiculo
            }));

            this.safeSetState({ listaModelos });

            return listaModelos;
        } catch (error) {
            console.error('Erro ao carregar modelos de veículo:', error);

            return [];
        }
    };

    /* Carrega os veículos */
    loadVeiculos = async (listaModelosCarregados) => {
        const { listaModelos, page, rowsPerPage, searchFilter } = this.state;
        const { capacidadepax, descveiculo, nroveiculo, situacaoInativoFilter } = searchFilter;
        const modelosBase = Array.isArray(listaModelosCarregados) ? listaModelosCarregados : listaModelos;

        const filtros = [
            {
                field: 'NROVEICULO',
                value: nroveiculo,
                operator: '_like_'
            },
            {
                field: 'DESCVEICULO',
                value: descveiculo,
                operator: '_like_'
            },
            {
                field: 'CAPACIDADEPAX',
                value: capacidadepax,
                operator: '_gte_'
            },
            {
                field: 'INATIVO',
                value: situacaoInativoFilter
            }
        ];

        if (searchFilter.modelos && searchFilter.modelos.length > 0) {
            const codigos = searchFilter.modelos.map(m => m.id);
            filtros.push({
                field: 'CODMODELOVEICULO',
                value: codigos.join(','),
                operator: '_in_'
            });
        }

        if (searchFilter.marcas && searchFilter.marcas.length > 0) {
            // pega os ids das marcas selecionadas
            const codigoMarcas = searchFilter.marcas.map(m => m.id);

            // filtra os modelos que pertencem a essas marcas
            const modelosRelacionados = modelosBase.filter(
                modelo => codigoMarcas.includes(modelo.codmarcaveiculo)
            ).map(modelo => modelo.id);

            if (modelosRelacionados.length > 0) {
                filtros.push({
                    field: 'CODMODELOVEICULO',
                    value: modelosRelacionados.join(','),
                    operator: '_in_'
                });
            }
        }

        if (searchFilter.fornecedores && searchFilter.fornecedores.length > 0) {
            const codigoFornecedores = searchFilter.fornecedores.map(f => f.id);
            filtros.push({
                field: 'CODFORNECEDORVEICULO',
                value: codigoFornecedores.join(','),
                operator: '_in_'
            });
        }

        if (searchFilter.veiculoproprio === true) {
            filtros.push({
                field: 'VEICULOPROPRIO',
                value: ASIM
            });
        }

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: filtros
        });

        try {
            const response = await api.get('/veiculo' + params);

            this.safeSetState({
                veiculos: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar veículos:', error);

            this.safeSetState({
                veiculos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadVeiculos);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadVeiculos);
    };

    /* Deleta o veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/veiculo/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadVeiculos();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir veículo!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codveiculo, nroveiculo) => {
        this.setState({
            open: true,
            selectedId: codveiculo,
            selectedDesc: nroveiculo
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { checked, name, type, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: type === 'checkbox'
                ? checked
                : (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisar os modelos de veículo */
    onChangeModelos = (selected) => {
        const searchFilter = {
            ...this.state.searchFilter,
            modelos: selected
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisar as marcas de veículo */
    onChangeMarcas = (selected) => {
        const searchFilter = {
            ...this.state.searchFilter,
            marcas: selected
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisa os fornecedores de veículo */
    onChangeFornecedores = (selected) => {
        const searchFilter = {
            ...this.state.searchFilter,
            fornecedores: selected
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            nroveiculo: '',
            descveiculo: '',
            capacidadepax: '',
            situacaoInativoFilter: ANAO,
            modelos: [],
            marcas: [],
            fornecedores: [],
            veiculoproprio: false
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadVeiculos);
    };

    render() {
        const {
            listaFornecedores,
            listaMarcas,
            listaModelos,
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems,
            veiculos
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="nroveiculo"
                        name="nroveiculo"
                        onChange={this.onChangeSearch}
                        placeholder="Veículo"
                        value={searchFilter.nroveiculo}
                        style={{
                            flex: '0 1 150px',
                            minWidth: 150
                        }}
                    />

                    <Input
                        id="descveiculo"
                        name="descveiculo"
                        onChange={this.onChangeSearch}
                        placeholder="Descrição"
                        value={searchFilter.descveiculo}
                        style={{
                            flex: '0 1 150px',
                            minWidth: 150
                        }}
                    />

                    <Input
                        id="capacidadepax"
                        name="capacidadepax"
                        onChange={this.onChangeSearch}
                        placeholder="Qtde. pax"
                        value={searchFilter.capacidadepax}
                        style={{
                            flex: '0 1 75px',
                            minWidth: 75
                        }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <FormControlLabel
                        label="Exibir somente veículos próprios"
                        control={
                            <Checkbox
                                checked={searchFilter.veiculoproprio}
                                name="veiculoproprio"
                                onChange={this.onChangeSearch}
                                color="primary"
                            />
                        }
                    />

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={() => this.loadVeiculos()}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/veiculo/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Box
                        style={{
                            flex: '0 1 250px',
                            minWidth: 250
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.marcas}
                            label="Marcas"
                            itens={listaMarcas}
                            onSelectionChange={this.onChangeMarcas}
                        />
                    </Box>

                    <Box
                        style={{
                            flex: '0 1 250px',
                            minWidth: 250
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.modelos}
                            label="Modelos"
                            itens={listaModelos}
                            onSelectionChange={this.onChangeModelos}
                        />
                    </Box>

                    <Box
                        style={{
                            flex: '0 1 250px',
                            minWidth: 250
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.fornecedores}
                            label="Fornecedores"
                            itens={listaFornecedores}
                            onSelectionChange={this.onChangeFornecedores}
                        />
                    </Box>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Veículo</TableCell>

                                            <TableCell align="center">Capacidade Pax</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {veiculos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={4}
                                                >
                                                    Nenhum veículo encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {veiculos.map(veiculo => (
                                            <TableRow
                                                hover
                                                key={veiculo.codveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.codveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.nroveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.capacidadepax}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/frotas/veiculo/${veiculo.codveiculo}`}>
                                                                <EditTwoTone
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/frotas/veiculo/${veiculo.codveiculo}/view`}>
                                                                <VisibilityOutlined
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlined
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                onClick={() => this.handleOpen(
                                                                    veiculo.codveiculo,
                                                                    veiculo.nroveiculo
                                                                )}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do veículo ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default VeiculoList;